import { realBricksApi } from '../../utils/axiosInterceptors';

export const downloadStatementService = (body) => {
  return realBricksApi.post(`/api/v1/user/account-statement`, body, {
    responseType: 'arraybuffer',
    headers: {
      Accept: 'application/pdf',
    },
  });
};

export const getTradeConfirmationService = (page, limit, startDate, endDate, tradeType) => {
  return realBricksApi.get(`/api/v1/payment/trade-confirmation?`, {
    params: {
      page,
      limit,
      startDate,
      endDate,
      ...(tradeType && { tradeType }),
    },
  });
};

export const getSubscriptionAgreementService = (page, limit, startDate, endDate) => {
  return realBricksApi.get(`/api/v1/payment/purchase-agreement?`, {
    params: {
      page,
      limit,
      startDate,
      endDate,
    },
  });
};
